<script setup lang="ts">
defineProps<{ step: number; title: string }>();
</script>

<template>
  <div class="space-y-4">
    <h2 class="h3 flex items-center gap-1.5">
      <span class="flex size-8 items-center justify-center rounded-full bg-primary text-xl text-white">{{ step }}</span>
      {{ title }}
    </h2>
    <slot />
  </div>
</template>
